// @ts-expect-error TS(7016)
import isUrl from "is-url";
import { Descendant } from "slate";

import { dateRegex, nonSpecialCharacters } from "helpers/regexp";
import { isEmail } from "helpers/validate";

/**
 * Higher order function used to compose multiple validators.
 * First encoutered error is returned.
 *
 * @example
 *
 * <Field
 *  validate={
 *    compose(
 *      required('Email is required'),
 *      email('Email is incorrect')
 *    )
 *  }
 * {...otherProps}
 * />
 *
 */
// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function compose(...validators: any[]): ValidatorFn {
  return (value, values) =>
    validators.reduce((err, v) => {
      if (err) return err;

      return v(value, values);
    }, undefined);
}

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
type ValidatorFn = (value: string | Descendant[], allValues?: any) => string | undefined;

// FIXME: Fix this the next time the file is edited.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function required(msg = "Field required"): (value: string | any[]) => string {
  // @ts-expect-error TS(2322): Type '(value: string | any[]) => string | undefine... Remove this comment to see the full error message
  return value => {
    if (Array.isArray(value)) {
      // FIXME: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const castedValue = value as any[];
      return !castedValue || castedValue.length === 0 ? msg : undefined;
    }
    const castedValue = value as string;
    return !castedValue || !castedValue.trim() ? msg : undefined;
  };
}

export function groupRequired(msg = "Group required"): ValidatorFn {
  // @ts-expect-error TS(2322): Type '(value: string) => string | undefined' is no... Remove this comment to see the full error message
  return (value: string) => (typeof value === "undefined" || value === null ? msg : undefined);
}

export function email(msg = "Email is incorrect"): ValidatorFn {
  // @ts-expect-error TS(2322): Type '(value: string) => string | undefined' is no... Remove this comment to see the full error message
  return (value: string) => (!isEmail(value) ? msg : undefined);
}

export function emailOrEmpty(msg = "Email is incorrect"): ValidatorFn {
  // @ts-expect-error TS(2322): Type '(value: string) => string | undefined' is no... Remove this comment to see the full error message
  return (value: string) => (value && value.length > 0 && !isEmail(value) ? msg : undefined);
}

export function matchFields(msg = "Field is required", matchWithField: string): ValidatorFn {
  // @ts-expect-error TS(2322): Type '(value: string, allValues: { [key: string]: ... Remove this comment to see the full error message
  return (value: string, allValues: { [key: string]: string }) =>
    allValues[matchWithField] && value !== allValues[matchWithField] ? msg : null;
}

export function minLength(msg = "Field value is too short", length: number): ValidatorFn {
  // @ts-expect-error TS(2322): Type '(value: string) => string | null' is not ass... Remove this comment to see the full error message
  return (value: string) => (value?.trim().length < length ? msg : null);
}

export function maxLength(msg = "Field value is too long", length: number): ValidatorFn {
  // @ts-expect-error TS(2322): Type '(value: string) => string | null' is not ass... Remove this comment to see the full error message
  return (value: string) => (value?.trim().length > length ? msg : null);
}

export function nonEmptyString(msg = "Value cannot be blank"): ValidatorFn {
  return value => (typeof value === "string" && value.trim().length > 0 ? undefined : msg);
}
export function nonSpecialChars(msg = "Value cannot contain special characters"): ValidatorFn {
  return value => (typeof value === "string" && nonSpecialCharacters.test(value.trim()) ? undefined : msg);
}

export function uniqueValue(msg = "Value is already in use", valuesInUse: string[]): ValidatorFn {
  // @ts-expect-error TS(2322): Type 'string | undefined' is not assignable to typ... Remove this comment to see the full error message
  return value => (valuesInUse.includes(value) ? msg : undefined);
}

export function url(msg = "Incorrect link format"): ValidatorFn {
  // @ts-expect-error TS(2322): Type '(value: string) => string | undefined' is no... Remove this comment to see the full error message
  return (value: string) => (value?.length > 0 && !isUrl(value) ? msg : undefined);
}
export function dateFormat(msg = "Use the correct date format"): ValidatorFn {
  return value => ((typeof value === "string" && dateRegex.test(value.trim())) || !value ? undefined : msg);
}

export function requiredMustacheVariable(msg = "Add required variable", variable: string): ValidatorFn {
  return value => {
    const stringValue = JSON.stringify(value);
    return stringValue?.trim().length > 0 &&
      !stringValue.includes(`{{${variable}}}`) &&
      !stringValue.includes(`{{{${variable}}}}`)
      ? msg
      : undefined;
  };
}

export function requiredRichText(msg = "Enter description"): (value: Descendant[]) => string | undefined {
  return value => {
    const firstNode = value[0] as { children?: { text?: string }[] };
    return firstNode?.children?.[0]?.text === "" ? msg : undefined;
  };
}
